import { LanguageCode } from '@biteinc/enums';
import { Strings as ar_sa } from './locales/strings.ar-sa.js';
import { Strings as de_de } from './locales/strings.de-de.js';
import { Strings as en_gb } from './locales/strings.en-gb.js';
import { CustomStringKey, Strings as en_us } from './locales/strings.en-us.js';
import { Strings as es_us } from './locales/strings.es-us.js';
import { Strings as fr_ca } from './locales/strings.fr-ca.js';
import { Strings as it_it } from './locales/strings.it-it.js';
import { Strings as ja_jp } from './locales/strings.ja-jp.js';
import { Strings as ko_kr } from './locales/strings.ko-kr.js';
import { Strings as pt_br } from './locales/strings.pt-br.js';
import { Strings as vi_vn } from './locales/strings.vi-vn.js';
import { Strings as zh_cn } from './locales/strings.zh-cn.js';
export { CustomStringKey } from './locales/strings.en-us.js';
export const LanguageStrings = {
    [LanguageCode.EN_US]: en_us,
    [LanguageCode.AR_SA]: ar_sa,
    [LanguageCode.EN_GB]: en_gb,
    [LanguageCode.FR_CA]: fr_ca,
    [LanguageCode.ES_US]: es_us,
    [LanguageCode.ZH_CN]: zh_cn,
    [LanguageCode.JA_JP]: ja_jp,
    [LanguageCode.KO_KR]: ko_kr,
    [LanguageCode.PT_BR]: pt_br,
    [LanguageCode.VI_VN]: vi_vn,
    [LanguageCode.DE_DE]: de_de,
    [LanguageCode.IT_IT]: it_it,
};
const options = {
    WELCOME_TO: {
        optionalParams: true,
    },
};
// legacy export for backwards compatibility
export const Strings = Object.fromEntries(Object.keys(CustomStringKey).map((key) => [
    key,
    {
        key: key,
        options: options[key],
        [LanguageCode.EN_US]: en_us[key],
        [LanguageCode.AR_SA]: ar_sa[key],
        [LanguageCode.EN_GB]: en_gb[key],
        [LanguageCode.FR_CA]: fr_ca[key],
        [LanguageCode.ES_US]: es_us[key],
        [LanguageCode.ZH_CN]: zh_cn[key],
        [LanguageCode.JA_JP]: ja_jp[key],
        [LanguageCode.KO_KR]: ko_kr[key],
        [LanguageCode.PT_BR]: pt_br[key],
        [LanguageCode.VI_VN]: vi_vn[key],
        [LanguageCode.DE_DE]: de_de[key],
        [LanguageCode.IT_IT]: it_it[key],
    },
]));
export function convertLocalizableString(localizableString, language, params = [], CustomStrings = {}, primaryLanguage) {
    // language -> the location's primary language -> English. The locale files are only partly
    // translated, so a store's primary language stands in before English does. English stays the
    // last resort because the primary language is just as likely to be blank.
    let string = localizableString[language];
    if (!string && primaryLanguage && primaryLanguage !== language) {
        string = localizableString[primaryLanguage];
    }
    if (!string && language !== LanguageCode.EN_US) {
        string = localizableString[LanguageCode.EN_US];
    }
    // A custom string wins whenever the language is present, including when it is empty: an empty
    // override deliberately renders nothing. A language that is absent falls through to the
    // localization file above rather than to another language's custom string — otherwise a german
    // guest would read an english override that was never meant for them.
    if (localizableString.key && CustomStrings[localizableString.key]) {
        const customString = CustomStrings[localizableString.key];
        if (language in customString) {
            string = customString[language] || '';
        }
    }
    // this is our own custom string interpolation
    // we use this so that we can place things like prices in the localized strings
    return params.reduce((replaced, param, i) => {
        const regex = new RegExp(`\\{\\{\\$${i + 1}[^}]*\\}\\}`);
        return replaced.replace(regex, param);
    }, 
    // if the value is not defined, we need to make sure we get a real string
    string || '');
}
export function customStringsToLanguageMap(customStrings) {
    return Object.entries(customStrings).reduce((acc, [customString, value]) => {
        Object.entries(value).forEach(([languageCode, translation]) => {
            if (!acc[languageCode]) {
                acc[languageCode] = {};
            }
            acc[languageCode][customString] = translation;
        });
        return acc;
    }, {});
}
//# sourceMappingURL=index.js.map